module.exports = __webpack_public_path__ + "img/card.dfd6c106.png";